module.exports = __webpack_public_path__ + "static/media/2-AirHeatExchanger - DX cool - No heat.a9476a75.png";